<template>
  <div class="app-container has-title">
    <bid-for-charge class="m-b-16" read-only :order-id="detail.orderId" />

    <div class="card">
      <div class="section">
        <base-section-title class="section-title" title="项目应收金额信息" />
        <div class="section-content">
          <jczh-descriptions
            :info="detail"
            :option="detailOption"
            :el-attrs="{
              labelStyle: {
                whiteSpace: 'nowrap'
              },
              contentStyle: {
                display: 'inline'
              }
            }"
          />
          <jczh-table-content
            :data="detail.invoiceForms || []"
            :option="chargeUnitListOption"
          />
        </div>
      </div>
    </div>

    <div class="card">
      <div class="section">
        <base-section-title class="section-title" title="开票信息" />
        <jczh-table-content
          class="section-content"
          :data="detail.invoiceForms || []"
          :option="chargeUnitInvoiceListOption"
        >
          <template v-slot:operate="{ row }">
            <a-button type="link" @click="lookInvoiceInfo(row)">
              查看开票信息
            </a-button>
          </template>
        </jczh-table-content>
      </div>
    </div>

    <!-- 开票信息弹窗 -->
    <a-modal
      v-model="invoiceInfoDialogVisible"
      title="开票信息"
      :mask-closable="false"
      :footer="null"
    >
      <jczh-descriptions
        :info="currentInvoice"
        :option="invoiceInfoOption"
        :el-attrs="{
          column: 1,
          labelStyle: {
            whiteSpace: 'nowrap'
          },
          contentStyle: {
            display: 'inline'
          }
        }"
      />
    </a-modal>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle.vue'
import BidForCharge from '@/components/entrust/agency-service-fee/BidForCharge.vue'
// 字典
import { bidWinWayDict } from '@/dictionary/project/bid'
import { whetherDict } from '@/dictionary/project/common'
import {
  agencyInvoiceTypeDict,
  amountFillTypeDict,
  chargeUnitTypeDict
} from '@/dictionary/agency-service-fee'
// 工具
import { strToThousands } from '@/utils/utils'
import { getAgencyServiceFeeIncomeInfoApi } from '@/api/agency/service-fee'

/**
 * @description 代理服务费收入详情信息
 */
export default {
  name: 'AgencyIncomeDetail',

  components: { BaseSectionTitle, BidForCharge },

  filters: {
    moneyFilter(value) {
      return strToThousands(value)
    }
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      detail: {},
      detailOption: [
        {
          label: '中标方式',
          prop: 'winType',
          filter: value => bidWinWayDict.translate(value)?.label
        },
        {
          label: '是否预借发票',
          prop: 'isBorrowInvoice',
          filter: value => whetherDict.translate(value)?.label || '-'
        },
        {
          label: '服务费收取单位',
          prop: 'chargeCompany',
          filter: value => chargeUnitTypeDict.translate(value)?.label || '-'
        }
      ],
      chargeUnitListOption: [
        { label: '收取单位名称', prop: 'companyName' },
        {
          label: '项目应收金额（元）',
          prop: 'needPayAmount',
          filter: value => strToThousands(value || '-')
        }
      ],
      // 开票列表配置
      chargeUnitInvoiceListOption: [
        { label: '收取单位名称', prop: 'companyName' },
        {
          label: '开票金额（元）',
          prop: 'invoiceAmount',
          filter: value => strToThousands(value || '-')
        },
        {
          label: '开票部门',
          prop: 'invoiceDept'
        },
        { label: '操作', slotName: 'operate' }
      ],
      // 当前查看的开票信息
      currentInvoice: {},
      // 开票信息弹窗显示
      invoiceInfoDialogVisible: false,
      // 开票信息配置
      invoiceInfoOption: [
        { label: '开票部门', prop: 'invoiceDept' },
        {
          label: '发票类型',
          prop: 'invoiceType',
          filter: value => agencyInvoiceTypeDict.translate(value)?.label || '-'
        },
        {
          label: '开票金额',
          prop: 'invoiceAmount',
          filter: value => strToThousands(value || '-') + ' 元'
        },
        { label: '单位名称', prop: 'companyName' },
        { label: '统一社会信用代码', prop: 'socialCreditCode' },
        { label: '电话', prop: 'mobile' },
        { label: '地址', prop: 'address' },
        { label: '开户行', prop: 'bank' },
        { label: '账户', prop: 'account' },
        { label: '备注', prop: 'remark' }
      ]
    }
  },

  computed: {
    incomeId() {
      return this.requestQuery?.incomeId
    }
  },

  created() {
    this.getDetail()
  },

  methods: {
    async getDetail() {
      try {
        const _res = await getAgencyServiceFeeIncomeInfoApi({
          incomeId: this.incomeId
        })
        this.detail = Object.assign({}, this.detail, _res.data?.agentFeeInfo)
        const incomeInfos = [_res.data?.incomeInfo || {}]
        this.detail.invoiceForms = (incomeInfos || []).map(item => {
          item.deptInfo = {
            name: item.invoiceDept,
            deptId: item.invoiceDeptId
          }
          return item
        })
        if (this.detail.amountType === amountFillTypeDict.SAME.value) {
          this.detail.chargeAmount = this.detail.invoiceForms[0].needPayAmount
        }
      } catch (err) {
        console.error('获取代理服务费收取失败', err)
        if (err?.message) this.$message.error(err.message)
      }
    },

    /**
     * 查看开票信息
     */
    lookInvoiceInfo(row) {
      this.currentInvoice = row
      this.invoiceInfoDialogVisible = true
    }
  }
}
</script>

<style scoped></style>
